import { DateCalendar as MUIDateCalendar } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { AQUAMARINE } from '../../../theme';
import { TextColor, TextKind, textStyleFrom } from '../Text';

const StyledMUIDateCalendar = styled(MUIDateCalendar<dayjs.Dayjs>)`
  .MuiPickersCalendarHeader-label {
    ${textStyleFrom(TextKind.TitleXs, TextColor.Primary)}
  }
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected:focus {
    background: ${AQUAMARINE};
  }
`;

export const DateCalendar: typeof MUIDateCalendar<dayjs.Dayjs> = ({
  shouldDisableDate,
  value,
  onChange,
}) => (
  <StyledMUIDateCalendar
    disablePast
    value={value}
    shouldDisableDate={shouldDisableDate}
    onChange={onChange}
  />
);
